import doCompactLogoUrl from '@/assets/Logo/do-compact-black.svg'
import { fluentIconWrapperSx } from '@/theme/sx/fluentIconWrapperSx.js'

export const dialogCtaIconSx = fluentIconWrapperSx(20, { color: 'text.secondary' })

export const APP_CONNECTION_CARD_WIDTH = '100%'

export const appConnectionCardSurfaceSx = {
  width: APP_CONNECTION_CARD_WIDTH,
  maxWidth: '100%',
  borderRadius: 'var(--app-radius-md)',
  boxSizing: 'border-box',
  overflow: 'hidden',
  fontFamily: 'var(--app-font-sans)',
  backgroundColor: 'var(--app-bg-hover)',
  border: 'none',
  boxShadow: 'none',
}

export const heroTileSize = 48
export const heroConnectorWidth = 240

export const brandingTileSx = {
  width: heroTileSize,
  height: heroTileSize,
  borderRadius: 'var(--app-radius-xs)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  background: 'linear-gradient(145deg, #1a1a1a 0%, #0a0a0a 52%, #000000 100%)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.06)',
}

export const doCompactLogoWhiteSx = {
  width: 27,
  height: 14,
  display: 'block',
  filter: 'brightness(0) invert(1)',
}

export { doCompactLogoUrl }
